/* eslint-disable no-console,no-useless-escape,getter-return,no-unused-vars */
import get from 'lodash/get';
import { debugEnabled } from '@whisper/utils/analytics';

export default class AnalyticsService {
  constructor() {
    if (!this.enabled) {
      if (this.debugEnabled) {
        console.warn(`${this.name} is disabled`);
      }

      return;
    }

    if (this.debugEnabled) {
      console.info(`${this.name} is enabled`);
    }
  }

  get debugEnabled() {
    return debugEnabled;
  }

  debug(message, data = {}) {
    if (!this.debugEnabled) {
      return;
    }

    console.info(`${this.name} debug: ${message}`, data);
  }

  track(eventName, data) {
    if (!this.enabled) {
      return;
    }

    this._track(eventName, data);
  }

  get currentPageTitle() {
    return get(window, 'document.title');
  }

  get currentPagePath() {
    return get(window, 'location.pathname');
  }

  // functions that each Analytics service class must implement or it will blow up:
  get name() {
    this.debug('\`get name()\` method must be implemented in service class');
  }

  get enabled() {
    this.debug('\`get enabled()\` method must be implemented in service class');
  }

  _track(eventName, data) {
    this.debug('\`_track(eventName, data)\` method must be implemented in service class');
  }
}
